import { render } from "./CheckoutCurtains.vue?vue&type=template&id=8541c250"
import script from "./CheckoutCurtains.vue?vue&type=script&lang=js"
export * from "./CheckoutCurtains.vue?vue&type=script&lang=js"

import "./CheckoutCurtains.vue?vue&type=style&index=0&id=8541c250&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__